import React from 'react';
import MultiStepSignup from './MultiStepSignup';

const RegisterPage = ({ onNavigate }) => {
  return <MultiStepSignup onNavigate={onNavigate} />;
};

export default RegisterPage;
